export class StarIcon {
    constructor(
        public isEmpty: boolean = false,
        public isFraction: boolean = false,
        public color: string
    ) {}
}